<template>
  <div class="container dark">
    <span class="baseline" v-html="$t('impactStudyOfTravelTimes')"></span>
  </div>
</template>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-image: url('./../../assets/brushredgrey.png');
  background-repeat: no-repeat;
  background-position: 0 50%;
  background-size: auto 100%;
  width: 100%;
  height: 100%;
  background-color: #0e0b1c;
}
.subtitle {
  color: colors.$earth-color;
  display: block;
  font-size: 2.125em;
  padding-top: 0.5em;
  text-align: center;

  &:after {
    content: '';
    display: block;
    margin: auto;
    width: 5.2941176471em;
    height: 1px;
    background-color: colors.$main-color;
    margin-top: 2em;
    margin-bottom: 2.9411764706em;
  }
}
.baseline {
  font-size: 96px;
  font-weight: 200;
  text-align: center;

  &:after {
    content: '';
    display: block;
    margin: 32px auto 0;
    width: 192px;
    height: 2px;
    background-color: colors.$main-color;
  }
}
</style>
